import Immutable from 'immutable';
import moment from 'moment';

const LOAD = 'farm/LOAD';
const LOAD_SUCCESS = 'farm/LOAD_SUCCESS';
const LOAD_FAIL = 'farm/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'farm/LOAD_ADD_SUCCESS';
const LOAD_ALL_SUCCESS = 'farm/LOAD_ALL_SUCCESS';
const LOAD_ALL_ACTIVE_SUCCESS = 'farm/LOAD_ALL_ACTIVE_SUCCESS';

const COMMENTS_LOAD = 'farm/COMMENTS_LOAD';
const COMMENTS_LOAD_SUCCESS = 'farm/COMMENTS_LOAD_SUCCESS';
const COMMENTS_LOAD_FAIL = 'farm/COMMENTS_LOAD_FAIL';
const COMMENTS_LOAD_ADD_SUCCESS = 'farm/COMMENTS_LOAD_ADD_SUCCESS';

const ADDITIONALTAX_LOAD_SUCCESS = 'farm/ADDITIONALTAX_LOAD_SUCCESS';
const ADDITIONALTAX_LOAD_FAIL = 'farm/ADDITIONALTAX_LOAD_FAIL';
const ADDITIONALTAX_LOAD_ADD_SUCCESS = 'farm/ADDITIONALTAX_LOAD_ADD_SUCCESS';

const COUNTY_LOAD = 'farm/COUNTY_LOAD';
const COUNTY_LOAD_SUCCESS = 'farm/COUNTY_LOAD_SUCCESS';
const COUNTY_LOAD_FAIL = 'farm/COUNTY_LOAD_FAIL';
const COUNTY_LOAD_ADD_SUCCESS = 'farm/COUNTY_LOAD_ADD_SUCCESS';

const PARCEL_LOAD = 'farm/PARCEL_LOAD';
const PARCEL_LOAD_SUCCESS = 'farm/PARCEL_LOAD_SUCCESS';
const PARCEL_LOAD_FAIL = 'farm/PARCEL_LOAD_LOAD_FAIL';
const PARCEL_LOAD_ADD_SUCCESS = 'farm/PARCEL_LOAD_ADD_SUCCESS';

const CROPINSTYPECOVERAGE_LOAD = 'farm/CROPINSTYPECOVERAGE_LOAD';
const CROPINSTYPECOVERAGE_LOAD_SUCCESS = 'farm/CROPINSTYPECOVERAGE_LOAD_SUCCESS';
const CROPINSTYPECOVERAGE_LOAD_FAIL = 'farm/CROPINSTYPECOVERAGE_LOAD_FAIL';

const CROPYEAR_LOAD = 'farm/CROPYEAR_LOAD';
const CROPYEAR_LOAD_SUCCESS = 'farm/CROPYEAR_LOAD_SUCCESS';
const CROPYEAR_LOAD_FAIL = 'farm/CROPYEAR_LOAD_FAIL';

const LIABILITYINSURANCE_LOAD = 'farm/LIABILITYINSURANCE_LOAD';
const LIABILITYINSURANCE_LOAD_SUCCESS = 'farm/LIABILITYINSURANCE_LOAD_SUCCESS';
const LIABILITYINSURANCE_LOAD_FAIL = 'farm/LIABILITYINSURANCE_LOAD_FAIL';
const LIABILITYINSURANCE_LOAD_ADD_SUCCESS = 'farm/LIABILITYINSURANCE_LOAD_ADD_SUCCESS';

const CROPTYPE_LOAD = 'farm/CROPTYPES_LOAD';
const CROPTYPE_LOAD_SUCCESS = 'farm/CROPTYPES_LOAD_SUCCESS';
const CROPTYPE_LOAD_FAIL = 'farm/CROPTYPES_LOAD_FAIL';

const CROPVARIETIES_LOAD = 'farm/CROPTYPES_LOAD';
const CROPVARIETIES_LOAD_SUCCESS = 'farm/CROPVARIETIES_LOAD_SUCCESS';
const CROPVARIETIES_LOAD_FAIL = 'farm/CROPTYPES_LOAD_FAIL';

const FERTILIZER_LOAD = 'farm/FERTILIZER_LOAD';
const FERTILIZER_LOAD_SUCCESS = 'farm/FERTILIZER_LOAD_SUCCESS';
const FERTILIZER_LOAD_FAIL = 'farm/FERTILIZER_LOAD_FAIL';

const ANNUALWEEDS_LOAD = 'farm/ANNUALWEEDS_LOAD';
const ANNUALWEEDS_LOAD_SUCCESS = 'farm/ANNUALWEEDS_LOAD_SUCCESS';
const ANNUALWEEDS_LOAD_FAIL = 'farm/ANNUALWEEDS_LOAD_FAIL';

const ANNUALWEEDSCHEMICAL_LOAD = 'farm/ANNUALWEEDSCHEMICAL_LOAD';
const ANNUALWEEDSCHEMICAL_LOAD_SUCCESS = 'farm/ANNUALWEEDSCHEMICAL_LOAD_SUCCESS';
const ANNUALWEEDSCHEMICAL_LOAD_FAIL = 'farm/ANNUALWEEDSCHEMICAL_LOAD_FAIL';

const DISEASES_LOAD = 'farm/DISEASES_LOAD';
const DISEASES_LOAD_SUCCESS = 'farm/DISEASES_LOAD_SUCCESS';
const DISEASES_LOAD_FAIL = 'farm/DISEASES_LOAD_FAIL';

const DISEASESACTION_LOAD = 'farm/DISEASESACTION_LOAD';
const DISEASESACTION_LOAD_SUCCESS = 'farm/DISEASESACTION_LOAD_SUCCESS';
const DISEASESACTION_LOAD_FAIL = 'farm/DISEASESACTION_LOAD_FAIL';

const NOXIOUSWEEDS_LOAD = 'farm/NOXIOUSWEEDS_LOAD';
const NOXIOUSWEEDS_LOAD_SUCCESS = 'farm/NOXIOUSWEEDS_LOAD_SUCCESS';
const NOXIOUSWEEDS_LOAD_FAIL = 'farm/NOXIOUSWEEDS_LOAD_FAIL';

const NOXIOUSWEEDSCHEMICALS_LOAD = 'farm/NOXIOUSWEEDSCHEMICALS_LOAD';
const NOXIOUSWEEDSCHEMICALS_LOAD_SUCCESS = 'farm/NOXIOUSWEEDSCHEMICALS_LOAD_SUCCESS';
const NOXIOUSWEEDSCHEMICALS_LOAD_FAIL = 'farm/NOXIOUSWEEDSCHEMICALS_LOAD_FAIL';

const FARMUPLOADS_LOAD = 'farm/FARMUPLOADS_LOAD';
const FARMUPLOADS_LOAD_SUCCESS = 'farm/FARMUPLOADS_LOAD_SUCCESS';
const FARMUPLOADS_LOAD_FAIL = 'farm/FARMUPLOADS_LOAD_FAIL';
const FARMUPLOADS_LOAD_ADD_SUCCESS = 'farm/FARMUPLOADS_LOAD_ADD_SUCCESS';

const FARMEOYUPLOADS_LOAD = 'farm/FARMEOYUPLOADS_LOAD';
const FARMEOYUPLOADS_LOAD_SUCCESS = 'farm/FARMEOYUPLOADS_LOAD_SUCCESS';
const FARMEOYUPLOADS_LOAD_FAIL = 'farm/FARMEOYUPLOADS_LOAD_FAIL';
const FARMEOYUPLOADS_LOAD_ADD_SUCCESS = 'farm/FARMEOYUPLOADS_LOAD_ADD_SUCCESS';

const FARMMISCUPLOADS_LOAD_SUCCESS = 'farm/FARMMISCUPLOADS_LOAD_SUCCESS';
const FARMMISCUPLOADS_LOAD_FAIL = 'farm/FARMMISCUPLOADS_LOAD_FAIL';

const PDFFILEUPLOADS_LOAD = 'farm/PDFFILEUPLOADS_LOAD';
const PDFFILEUPLOADS_LOAD_SUCCESS = 'farm/PDFFILEUPLOADS_LOAD_SUCCESS';
const PDFFILEUPLOADS_LOAD_FAIL = 'farm/PDFFILEUPLOADS_LOAD_FAIL';

const SENDEMAIL_LOAD = 'farm/SENDEMAIL_LOAD';
const SENDEMAIL_LOAD_SUCCESS = 'farm/SENDEMAIL_LOAD_SUCCESS';
const SENDEMAIL_LOAD_FAIL = 'farm/SENDEMAIL_LOAD_FAIL';

const SEND_TO_PORTAL = 'farm/SEND_TO_PORTAL';
const SEND_TO_PORTAL_SUCCESS = 'farm/SEND_TO_PORTAL_SUCCESS';
const SEND_TO_PORTAL_FAIL = 'farm/SEND_TO_PORTAL_FAIL';

const MESSAGE_LOAD = 'farm/MESSAGE_LOAD';
const MESSAGE_LOAD_SUCCESS = 'farm/MESSAGE_LOAD_SUCCESS';
const MESSAGE_LOAD_FAIL = 'farm/MESSAGE_LOAD_FAIL';
const MESSAGE_LOAD_ADD_SUCCESS = 'farm/MESSAGE_LOAD_ADD_SUCCESS';

const GET_MASS_MESSAGES_FAIL = 'farm/GET_MASS_MESSAGES_FAIL';
const GET_MASS_MESSAGES_SUCCESS = 'farm/GET_MASS_MESSAGES_SUCCESS'

const UPDATE_MASS_MESSAGES_FAIL = 'farm/UPDATE_MASS_MESSAGES_FAIL';
const UPDATE_MASS_MESSAGES_SUCCESS = 'farm/UPDATE_MASS_MESSAGES_SUCCESS';

const FARMINSPUPLOADS_LOAD_FAIL = 'farm/FARMINSPUPLOADS_LOAD_FAIL';
const FARMINSPUPLOADS_LOAD_ADD_SUCCESS = 'farm/FARMINSPUPLOADS_LOAD_ADD_SUCCESS';

const GET_INSP_UPLOADS_FAIL = 'farm/GET_INSP_UPLOADS_FAIL';
const GET_INSP_UPLOADS_SUCCESS = 'farm/GET_INSP_UPLOADS_SUCCESS';

const INSPECTION_IMG_LOAD_SUCCESS = 'farm/INSPECTION_IMG_LOAD_SUCCESS';
const INSPECTION_IMG_LOAD_FAIL = 'farm/INSPECTION_IMG_LOAD_FAIL';

const REMOVE_INSPECTION_IMG_LOAD_SUCCESS = 'farm/REMOVE_INSPECTION_IMG_LOAD_SUCCESS';
const REMOVE_INSPECTION_IMG_LOAD_FAIL = 'farm/REMOVE_INSPECTION_IMG_LOAD_FAIL';

const LEASE_PDF_SUCCESS = 'farm/LEASE_PDF_SUCCESS';
const LEASE_PDF_FAIL = 'farm/LEASE_PDF_FAIL';

const initialState = Immutable.fromJS({
  Farms: null,
  AllFarms: [],
  activeFormAndTenants: [],
  additionalTax:null,
  county:null,
  parcel:null,
  loading: false,
  cropInsTypeCoverage:null,
  cropYear:null,
  cropType:null,
  cropVarieties:null,
  liabilityInsurance:null,
  fertilizer:null,
  annualWeeds:null,
  annualWeedsChemicals:null,
  diseases:null,
  diseasesAction:null,
  noxiousWeeds:null,
  noxiousWeedsChemicals:null,
  errorMessage: null,
  activePage: 1,
  farmUploads:null,
  farmEoyUploads:null,
  farmMiscUploads:null,
  massMessage: null,
  getInspImage: null,
  imgFileUploads: null,
  leasePdfFile: null,
  farm: {
    farmName: '',
    asset: '',
    active: true
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('Farm', action.Farm);


    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false);

    case LOAD_ALL_SUCCESS:
    return state
    .set('loading', false)
    .set('AllFarms', action.Farms);

    case LOAD_ALL_ACTIVE_SUCCESS:
    return state
    .set('loading', false)
    .set('activeFormAndTenants', action.Farms);  

    case COMMENTS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case COMMENTS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('comments', action.comments);


    case COMMENTS_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('comments', action.result);

    case ADDITIONALTAX_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case ADDITIONALTAX_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('additionalTax', action.additionalTax);


    case ADDITIONALTAX_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('additionalTax', action.result);


    case COUNTY_LOAD:
    return state
    .set('loading', true);

    case COUNTY_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case COUNTY_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('county', action.county);


    case COUNTY_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('county', action.result);

    case PARCEL_LOAD:
    return state
    .set('loading', true);

    case PARCEL_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case PARCEL_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('parcel', action.parcel);


    case PARCEL_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('parcel', action.result);

    case CROPINSTYPECOVERAGE_LOAD:
    return state
    .set('loading', true);

    case CROPINSTYPECOVERAGE_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPINSTYPECOVERAGE_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropInsTypeCoverage', action.cropInsTypeCoverage);


    case CROPYEAR_LOAD:
    return state
    .set('loading', true);

    case CROPYEAR_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPYEAR_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropYear', action.cropYear);

    case LIABILITYINSURANCE_LOAD:
    return state
    .set('loading', true);

    case LIABILITYINSURANCE_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LIABILITYINSURANCE_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('liabilityInsurance', action.liabilityInsurance);

    case LIABILITYINSURANCE_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('liabilityInsurance', action.result);

    case CROPTYPE_LOAD:
    return state
    .set('loading', true);

    case CROPTYPE_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPTYPE_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropType', action.cropType);

    case CROPVARIETIES_LOAD:
    return state
    .set('loading', true);

    case CROPVARIETIES_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case CROPVARIETIES_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('cropVarieties', action.cropVarieties);

    case FERTILIZER_LOAD:
    return state
    .set('loading', true);

    case FERTILIZER_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case FERTILIZER_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('fertilizer', action.fertilizer);

    case ANNUALWEEDS_LOAD:
    return state
    .set('loading', true);

    case ANNUALWEEDS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case ANNUALWEEDS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('annualWeeds', action.annualWeeds);

    case ANNUALWEEDSCHEMICAL_LOAD:
    return state
    .set('loading', true);

    case ANNUALWEEDSCHEMICAL_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case ANNUALWEEDSCHEMICAL_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('annualWeedsChemicals', action.annualWeedsChemicals);

    case DISEASES_LOAD:
    return state
    .set('loading', true);

    case DISEASES_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case DISEASES_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('diseases', action.diseases);

    case DISEASESACTION_LOAD:
    return state
    .set('loading', true);

    case DISEASESACTION_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case DISEASESACTION_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('diseasesAction', action.diseasesAction);


    case NOXIOUSWEEDS_LOAD:
    return state
    .set('loading', true);

    case NOXIOUSWEEDS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case NOXIOUSWEEDS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('noxiousWeeds', action.noxiousWeeds);


    case NOXIOUSWEEDSCHEMICALS_LOAD:
    return state
    .set('loading', true);

    case NOXIOUSWEEDSCHEMICALS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case NOXIOUSWEEDSCHEMICALS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('noxiousWeedsChemicals', action.noxiousWeedsChemicals);


    case FARMUPLOADS_LOAD:
    return state
    .set('loading', true);

    case FARMUPLOADS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case FARMUPLOADS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('farmUploads', action.farmUploads);


    case FARMUPLOADS_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('farmUploads', action.result);

    case PDFFILEUPLOADS_LOAD:
    return state
    .set('loading', true);

    case PDFFILEUPLOADS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case PDFFILEUPLOADS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('pdfFileUploads', action.pdfFileUploads);

    case FARMEOYUPLOADS_LOAD:
    return state
    .set('loading', true);

    case FARMEOYUPLOADS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case FARMEOYUPLOADS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('farmEoyUploads', action.farmEoyUploads);


    case FARMEOYUPLOADS_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('farmEoyUploads', action.result);

    case SENDEMAIL_LOAD:
    return state
    .set('loading', true);

    case SENDEMAIL_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case SENDEMAIL_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('sendEmails', action.sendEmails);

    case SEND_TO_PORTAL:
    return state
    .set('loading', true);

    case SEND_TO_PORTAL_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case SEND_TO_PORTAL_SUCCESS:
    return state
    .set('loading', false)
    .set('sendToPortal', action.sendToPortal);

    case GET_MASS_MESSAGES_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case GET_MASS_MESSAGES_SUCCESS:
    return state
    .set('loading', false)
    .set('massMessage', action.sendToPortal);

    case UPDATE_MASS_MESSAGES_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case UPDATE_MASS_MESSAGES_SUCCESS:
    return state
    .set('loading', false)
    .set('massMessage', action.sendToPortal);

    case FARMINSPUPLOADS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case FARMINSPUPLOADS_LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('farmUploads', action.farmUploads);

    case GET_INSP_UPLOADS_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case GET_INSP_UPLOADS_SUCCESS:
    return state
    .set('loading', false)
    .set('getInspImage', action.getInspImage);

    case INSPECTION_IMG_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case INSPECTION_IMG_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('imgFileUploads', action.imgFileUploads);

    case REMOVE_INSPECTION_IMG_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case REMOVE_INSPECTION_IMG_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('imgFileUploads', action.imgFileUploads);

    case LEASE_PDF_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LEASE_PDF_SUCCESS:
    return state
    .set('loading', false)
    .set('leasePdfFile', action.leasePdfFile);

    default:
    return state;
  }
}

export const getFarms = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/farm');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ALL_SUCCESS, Farms: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getFarmById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });  
  try {    
    let res = await api.get('/farm/farmGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    res = Object.assign({}, res, { 
      selectedValue1: { selection: 1, farm_id: id },
      selectedValue2: { selection: 2, farm_id: id },
      selectedValue3: { selection: 3, farm_id: id },
      active: res.active === '1',
      portal_access: res.portal_access === '1'
    })
    res.mVDateCompleted = res.mVDateCompleted ? moment.utc(res.mVDateCompleted).format('MM/DD/YYYY') : res.mVDateCompleted;
    if(res.farm_selectedValues && res.farm_selectedValues.length > 0) {
      res.farm_selectedValues.forEach(sv => {
        sv.dateSold = sv.dateSold ? moment.utc(sv.dateSold).format('MM/DD/YYYY') : null;
        switch (Number(sv.selection)) {
          case 1 : 
            res.selectedValue1 = sv;
          break;
          case 2 : 
            res.selectedValue2 = sv;
          break;
          case 3 : 
            res.selectedValue3 = sv;
          break;

          default:
            console.log('')
          break;
        }
      });
    }
    dispatch({ type: LOAD_SUCCESS, Farm: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addFarm = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getFarmOwnerList = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/ownerDetailById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getFarmTenantList = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/tenantsDetailById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateFarm = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const farms = getState().get('farm').get('AllFarms');
    const index = farms.findIndex(farm => farm.id === data.id);
    farms[index] = Object.assign({}, farms[index], {
      farmName: res.farmName,
      asset: res.asset,
      active: res.active === '1',
      portal_access: res.portal_access === '1'
    })

    dispatch({ type: LOAD_ALL_SUCCESS, Farms: Object.assign({}, farms) });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteFarm = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/farm', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const farms = getState().get('farm').get('AllFarms');
    const list = farms.filter(farm => farm.id !== data.id);
  
    dispatch({ type: LOAD_ALL_SUCCESS, Farms: list });
    return list;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/* getting farm comments */
export const getComments = (farmId) => async (dispatch, _getState, api) => {
  dispatch({ type: COMMENTS_LOAD });
  try {
    const res = await api.get('/farm/farmGetComment/' + farmId);
    if (res.message) {
      dispatch({ type: COMMENTS_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: COMMENTS_LOAD_SUCCESS, comments: res });
    return res;
  } catch (error) {
    dispatch({ type: COMMENTS_LOAD_FAIL, errorMessage: error });
  }
};

export const getSale = (sale, selection) => {
  return {
    acres: sale.acres,
    buyer: sale.buyer,
    county: sale.county,
    dateSold: sale.date_Sold ? moment.utc(sale.date_Sold).format('MM/DD/YYYY') : '',
    per_acre: sale.per_acre,
    price: sale.price,
    seller: sale.seller,
    totAcres: sale.tot_Acres,
    selection: selection
  }
}

export const setSale = (selectedSale, index, farm) => (dispatch, getState) => new Promise((resolve, reject) => {
  const data = getState().get('mvSalesComparisons').get('MvSalesComparisons');

  const selectedValue = data.rows[index];
  const saleValue = getSale(selectedValue, selectedSale);
  saleValue.farm_id = farm.id;

  if(selectedSale === 1) {
    if(farm.selectedValue1.id) {
      saleValue.id = farm.selectedValue1.id
    }    
    farm = Object.assign({}, farm, { selectedValue1: saleValue });
  } else if (selectedSale === 2) {
    if(farm.selectedValue2.id) {
      saleValue.id = farm.selectedValue2.id
    }
    farm = Object.assign({}, farm, { selectedValue2: saleValue });
  } else if (selectedSale === 3) {
    if(farm.selectedValue3.id) {
      saleValue.id = farm.selectedValue3.id
    }
    farm = Object.assign({}, farm, { selectedValue3: saleValue });
  }

  dispatch({ type: LOAD_SUCCESS, Farms: farm });
  resolve(farm);
});
/* delete comments */

export const deleteComments = (dataID) => async (dispatch, _getState, api) => {
  const data = { id : dataID };
  dispatch({ type: COMMENTS_LOAD });
  try {
    const res = await api.del('/farm/farmDeleteComment', { data });
    if (res.message) {
      dispatch({ type: COMMENTS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    
    dispatch({ type: COMMENTS_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: COMMENTS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const farmAddComment = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: COMMENTS_LOAD });
  try {
    const res = await api.post('/farm/farmAddComment', { data });
    if (res.message) {
      dispatch({ type: COMMENTS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: COMMENTS_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getOwnerAndTenant = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('farm/ownerAndTenant/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateOwnerAndTenantPdf = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/generateOwnerAndTenantPdf', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/* Get Additional Tax */
export const getAdditionalTax = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/additionalTax/' + id );
    if (res.message) {
      dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let list = [];
    if(res && res.length === 0) {
      list.push({
        farm_id: id,
        currYear: moment().year(),
        preYear: moment().year() - 1,
        farm_additional_tax_counties: [{
          name: '',
          farm_additional_tax_county_parcels: [{
            name: '',
            currYear: null,
            preYear: null
          }]
        }]       
      })
    } else {
      list = res.map(tax => {
        if(tax.farm_additional_tax_counties.length === 0) {
          tax.farm_additional_tax_counties = [{
            name: '',
            farm_additional_tax_county_parcels: [{
              name: '',
              currYear: null,
              preYear: null
            }]
          }] 
        } else {
          const counties = tax.farm_additional_tax_counties.map(county => {
            if(county.farm_additional_tax_county_parcels.length === 0) {
              county.farm_additional_tax_county_parcels = [{
                county_id: county.id,
                name: '',
                currYear: null,
                preYear: null
              }]
            }
            return county;
          })
          tax.farm_additional_tax_counties = counties;
        }
        return tax;
      })
    }

    const sortedList = list.sort((a, b) => { return Number(b.currYear)- Number(a.currYear) });

    const finalList = sortedList.map(res => {
      const isHalfYear = res.isCountyForHalfYear ? (res.isCountyForHalfYear === '1') : false;
      return Object.assign({}, res, { isCountyForHalfYear: isHalfYear })
    })
    
    dispatch({ type: ADDITIONALTAX_LOAD_SUCCESS, additionalTax: { data: finalList } }); 
    return sortedList;    
  } catch (error) {
    dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: error });
  }
};

export const updateAdditionalTax = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/additionaltax/', { data });
    if (res.message) {
      dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: error });
  }
};

export const addTax = (taxes, currYear, farm_id, prevYear) => (dispatch) => new Promise((resolve, _reject) => {
  let name = '';
  let newTax = {};
  if(taxes.length > 0){
    newTax = Object.assign({},taxes[0]);
    let farmAddtionalCounties = newTax.farm_additional_tax_counties.map(result => {
      return {
        name: result.name, 
        farm_additional_tax_county_parcels : result.farm_additional_tax_county_parcels.map(response => {
          return {
            name: response.name,
            preYear: response.currYear,
            currYear: ''
          }
        })
      }
    })
    newTax.farm_additional_tax_counties = farmAddtionalCounties
    newTax.farm_id = farm_id
    newTax.currYear = currYear
    newTax.preYear = currYear - 1
    newTax.id = ''
    newTax.isCountyForHalfYear = false
  } else {
    newTax = {
      farm_id,
      currYear,
      preYear: prevYear,
      isCountyForHalfYear: false,
      farm_additional_tax_counties: [{
        name: name,
        farm_additional_tax_county_parcels: []
      }]
    }
  }
  taxes.splice(0,0,newTax);
  dispatch({ type: ADDITIONALTAX_LOAD_SUCCESS, additionalTax: { data: taxes } }); 
  resolve(taxes); 
});

export const removeTax = (model, index) => async (dispatch, getState, api) => {
  const additionalTax = getState().get('farm').get('additionalTax');
  const taxes = additionalTax.data;
  let leftTaxes = [];
  try {
    if (model.id) {
      const data = { id: model.id };
      const res = await api.put('/farm/deleteAdditionalTax', { data });
      if (res.message) {
        dispatch({ type: COUNTY_LOAD_FAIL, errorMessage: res.message });
        return;
      }
      leftTaxes = taxes.filter(tax => tax.id !== model.id);     
    } else {
      leftTaxes = taxes.filter((tax, key) => key !== index);
    }
    dispatch({ type: ADDITIONALTAX_LOAD_SUCCESS, additionalTax: { data: leftTaxes } }); 
    return leftTaxes;
  } catch (error) {
    dispatch({ type: COUNTY_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getFarmAssetsMarketValueDueWorksheet = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/Assets/MarketValueDue/', { data } );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getFarmAssetsMarketValueSalesWorksheet = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/Assets/MarketValueSales/', { data } );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getCropInsTypeCoverage = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/cropInsTypeCoverage/');
    if (res.message) {
      dispatch({ type: CROPINSTYPECOVERAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CROPINSTYPECOVERAGE_LOAD_SUCCESS, cropInsTypeCoverage: res });
    return res;
  } catch (error) {
    dispatch({ type: CROPINSTYPECOVERAGE_LOAD_FAIL, errorMessage: error });
  }
};

export const getCropYear = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/cropYear/');
    if (res.message) {
      dispatch({ type: CROPYEAR_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CROPYEAR_LOAD_SUCCESS, cropYear: res });
    return res;
  } catch (error) {
    dispatch({ type: CROPYEAR_LOAD_FAIL, errorMessage: error });
  }
};

/* Get Liability  */
export const getLiability = (id) => async (dispatch, _getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/farm/liability/' + id );
    if (res.message) {
      dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LIABILITYINSURANCE_LOAD_SUCCESS, liabilityInsurance: res });
    return res;

  } catch (error) {
    dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: error });
  }
};

/* Add Liability */
export const addLiability = (data) => async (dispatch, _getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/liability/', { data });
    if (res.message) {
      dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LIABILITYINSURANCE_LOAD_ADD_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type:LIABILITYINSURANCE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateLiability = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/liability/', { data });
    if (res.message) {
      dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LIABILITYINSURANCE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/* delete County */
export const deleteLiability = (dataid) => async (dispatch, _getState, api) => {
  const data = {id:dataid};
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/farm/liability/', { data });
    if (res.message) {
      dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LIABILITYINSURANCE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LIABILITYINSURANCE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCropTypes = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/cropType/');
    if (res.message) {
      dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CROPTYPE_LOAD_SUCCESS, cropType: res });
    return res;
  } catch (error) {
    dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: error });
  }
};

export const getCropVarieties = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/cropVarieties/');
    if (res.message) {
      dispatch({ type: CROPVARIETIES_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CROPVARIETIES_LOAD_SUCCESS, cropVarieties: res });
    return res;
  } catch (error) {
    dispatch({ type: CROPVARIETIES_LOAD_FAIL, errorMessage: error });
  }
};

export const getFertilizer = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/fertilizer/');
    if (res.message) {
      dispatch({ type: FERTILIZER_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FERTILIZER_LOAD_SUCCESS, fertilizer: res });
    return res;
  } catch (error) {
    dispatch({ type: FERTILIZER_LOAD_FAIL, errorMessage: error });
  }
};

export const getAnnualWeeds = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/annualWeeds/');
    if (res.message) {
      dispatch({ type: ANNUALWEEDS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: ANNUALWEEDS_LOAD_SUCCESS, annualWeeds: res });
    return res;
  } catch (error) {
    dispatch({ type: ANNUALWEEDS_LOAD_FAIL, errorMessage: error });
  }
};

export const getAnnualWeedsChemical = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/annualWeedsChemical/');
    if (res.message) {
      dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_SUCCESS, annualWeedsChemicals: res });
    return res;
  } catch (error) {
    dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_FAIL, errorMessage: error });
  }
};

export const getDiseases = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/diseases/');
    if (res.message) {
      dispatch({ type:DISEASES_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:DISEASES_LOAD_SUCCESS, diseases: res });
    return res;
  } catch (error) {
    dispatch({ type:DISEASES_LOAD_FAIL, errorMessage: error });
  }
};

export const getDiseasesAction = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/diseasesAction/');
    if (res.message) {
      dispatch({ type:DISEASESACTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:DISEASESACTION_LOAD_SUCCESS, diseasesAction: res });
    return res;
  } catch (error) {
    dispatch({ type:DISEASESACTION_LOAD_FAIL, errorMessage: error });
  }
};

export const getNoxiousWeeds = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/noxiousWeeds/');
    if (res.message) {
      dispatch({ type:NOXIOUSWEEDS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:NOXIOUSWEEDS_LOAD_SUCCESS, noxiousWeeds: res });
    return res;
  } catch (error) {
    dispatch({ type:NOXIOUSWEEDS_LOAD_FAIL, errorMessage: error });
  }
};

export const getNoxiousWeedsChemicals = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/noxiousWeedsChemicals/');
    if (res.message) {
      dispatch({ type:NOXIOUSWEEDSCHEMICALS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:NOXIOUSWEEDSCHEMICALS_LOAD_SUCCESS, noxiousWeedsChemicals: res });
    return res;
  } catch (error) {
    dispatch({ type:NOXIOUSWEEDSCHEMICALS_LOAD_FAIL, errorMessage: error });
  }
};

export const reviewInspections = (query) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/reviewInspections', { data: query });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const printInspections = (query) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/printInspections', { data: query });
    if (res.message) {
      dispatch({ type:LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type:LOAD_FAIL, errorMessage: error });
  }
};

/* Get Elev and crop */
export const getElevAndCrop = (id) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/elevAndCrop/' + id );
    if (res.message) {
      dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: error });
  }
};

/* Get distinct Elev values across all crop production records */
export const getDistinctElev = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/distinctElev/');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateCropProSalesPdf = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/getCropSelectedSales', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updatefarmMarketValueUpdate = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/updatefarmMarketValueUpdate/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const printMarketValues = (data) => async (dispatch, getState, api) => {
  try {
    const res = await api.post('/farm/printMarketValues', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getAllFarm = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/farm/farmAll/`, { params });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ALL_SUCCESS, Farms: res });
    return res.farms;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getActiveFarmsAndTenant = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/farm/farmAll/`, { params : { ...params , active:1} });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ALL_ACTIVE_SUCCESS, Farms: res });
    return res.farms;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getFarmAssetsMarketValueCycleWorksheet = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/Assets/MarketValueCycle/', { data } );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteFarmUploadsById = (id) => async (dispatch, _getState, api) => {
    const data = {id: id };
    dispatch({ type: LOAD });
    try {
      const res = await api.del('/farm/farmDeleteInternalUpload', { data });
      if (res.message) {
        dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: res.message });
        return;
        }
      dispatch({ type:  FARMUPLOADS_LOAD_SUCCESS, farmUploads: res });
      return res;
    } catch (error) {
      dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
    }
};

export const getUploadsByFarmId = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });


  try {
    const res = await api.get('/farm/getUploadsByFarmId/' + id );
    if (res.message) {
      dispatch({ type:  FARMUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:FARMUPLOADS_LOAD_SUCCESS, farmUploads: res });
    return res;

  } catch (error) {
    dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: error });
  }
};

export const farmAddInternalUpload = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/farmAddInternalUpload', { data });
    if (res.message) {
      dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMUPLOADS_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const addToPastFile = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/addRemovePastFile', { data });
    if (res.message) {
      dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMUPLOADS_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * User pre-signed in
 */

export const pdfFilesDetail = (data) => async (dispatch, getState, api) => {

  dispatch({ type: PDFFILEUPLOADS_LOAD });
  try {
    const res = await api.put('/farm/pdfFileUploads/', { data });
    if (res.message) {
      dispatch({ type: PDFFILEUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: PDFFILEUPLOADS_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: PDFFILEUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const farmDeleteFinacialUpload = (id) => async (dispatch, getState, api) => {
    const data = {id: id };
    dispatch({ type: LOAD });
    try {
      const res = await api.del('/farm/farmDeleteFinacialUpload', { data });
      if (res.message) {
        dispatch({ type: LOAD_FAIL, errorMessage: res.message });
        return;
      }
      dispatch({ type:  FARMEOYUPLOADS_LOAD_SUCCESS, farmEoyUploads: res });
      return res;
    } catch (error) {

      dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
    }
};

export const farmAddFinacialUpload = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/farmAddFinacialUpload', { data });
    if (res.message) {
      dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMEOYUPLOADS_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getEoyUploadsByFarmId = (id) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });

    try {
      const res = await api.get('/farm/getEoyUploadsByFarmId/' + id );
      if (res.message) {
        dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: res.message });
        return;
      }
      dispatch({ type:FARMUPLOADS_LOAD_SUCCESS, farmEoyUploads: res });
      return res;
    } catch (error) {
      dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: error });
    }

  };

export const farmDeleteMiscUpload = (id) => async (dispatch, getState, api) => {
    const data = {id: id };
    dispatch({ type: LOAD });
    try {
      const res = await api.del('/farm/farmDeleteMiscUpload', { data });
      if (res.message) {

        dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: res.message });
        return;
      }
    dispatch({ type: FARMMISCUPLOADS_LOAD_SUCCESS, result: res });

    return res;
    } catch (error) {
      dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
    }
};

export const farmAddMiscUpload = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/farmAddMiscUpload', { data });
    if (res.message) {
      dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getMiscUploadsByFarmId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/farm/getMiscUploadsByFarmId/' + id );
    if (res.message) {
      dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type:FARMMISCUPLOADS_LOAD_SUCCESS, farmMiscUploads: res });
    return res;
  } catch (error) {
    dispatch({ type:FARMMISCUPLOADS_LOAD_FAIL, errorMessage: error });
  }
};

export const updateMainFarm = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const generateAdditionalTaxPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.post('/farm/additionalTaxPdf', {data} );
    if (res.message) {
      dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    return res;

  } catch (error) {
    dispatch({ type: ADDITIONALTAX_LOAD_FAIL, errorMessage: error });
  }
};

export const addCrop = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/cropType/', { data });
    if (res.message) {
      dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const cropTypes = getState().get('farm').get('cropType');
    cropTypes.push(res);

    dispatch({ type: CROPTYPE_LOAD_SUCCESS, cropType:  Object.assign([], cropTypes) });
    return res;
  } catch (error) {
    dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: error });
  }
};

export const addVariety = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/cropVarieties/', { data });
    if (res.message) {
      dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const cropVarieties = getState().get('farm').get('cropVarieties');
    cropVarieties.push({cropVarieties : res.Crop_Varieties});

    dispatch({ type: CROPVARIETIES_LOAD_SUCCESS, cropVarieties: Object.assign([], cropVarieties) });
    return res;
  } catch (error) {
    dispatch({ type: CROPTYPE_LOAD_FAIL, errorMessage: error });
  }
};

export const addFertilizer = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/fertilizer/', { data });
    if (res.message) {
      dispatch({ type: FERTILIZER_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const fertilizers = getState().get('farm').get('fertilizer');
    fertilizers.push(res);

    dispatch({ type: FERTILIZER_LOAD_SUCCESS, fertilizer: Object.assign([], fertilizers) });
    return res;
  } catch (error) {
    dispatch({ type: FERTILIZER_LOAD_FAIL, errorMessage: error });
  }
};

export const addAnnualWeeds = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/annualWeeds/', { data });
    if (res.message) {
      dispatch({ type: ANNUALWEEDS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const annualWeeds= getState().get('farm').get('annualWeeds');
    annualWeeds.push(res);

    dispatch({ type: ANNUALWEEDS_LOAD_SUCCESS, annualWeeds: Object.assign([], annualWeeds) });
    return res;
  } catch (error) {
    dispatch({ type: ANNUALWEEDS_LOAD_FAIL, errorMessage: error });
  }
};

export const addAnnualWeedsChemical = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/annualWeedsChemical/', { data });
    if (res.message) {
      dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const annualWeedChemicals = getState().get('farm').get('annualWeedsChemicals');
    annualWeedChemicals.push(res);

    dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_SUCCESS, annualWeedsChemicals: Object.assign([], annualWeedChemicals) });
    return res;
  } catch (error) {
    dispatch({ type:ANNUALWEEDSCHEMICAL_LOAD_FAIL, errorMessage: error });
  }
};

export const addNoxiousWeeds = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/noxiousWeeds/', { data });
    if (res.message) {
      dispatch({ type:NOXIOUSWEEDS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const noxiousWeeds = getState().get('farm').get('noxiousWeeds');
    noxiousWeeds.push(res);

    dispatch({ type:NOXIOUSWEEDS_LOAD_SUCCESS, noxiousWeeds: Object.assign([], noxiousWeeds) });
    return res;
  } catch (error) {
    dispatch({ type:NOXIOUSWEEDS_LOAD_FAIL, errorMessage: error });
  }
};

export const addNoxiousWeedsChemicals = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/noxiousWeedsChemicals/', { data });
    if (res.message) {
      dispatch({ type:NOXIOUSWEEDSCHEMICALS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const noxiousWeedsChemicals = getState().get('farm').get('noxiousWeedsChemicals');
    noxiousWeedsChemicals.push(res);

    dispatch({ 
      type: NOXIOUSWEEDSCHEMICALS_LOAD_SUCCESS, 
      noxiousWeedsChemicals: Object.assign([], noxiousWeedsChemicals) 
    });
    
    return res;
  } catch (error) {
    dispatch({ type:NOXIOUSWEEDSCHEMICALS_LOAD_FAIL, errorMessage: error });
  }
};

export const addDiseases = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/diseases/', { data });
    if (res.message) {
      dispatch({ type:DISEASES_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const diseases = getState().get('farm').get('diseases');
    diseases.push(res);

    dispatch({ type:DISEASES_LOAD_SUCCESS, diseases: Object.assign([], diseases) });
    return res;
  } catch (error) {
    dispatch({ type:DISEASES_LOAD_FAIL, errorMessage: error });
  }
};

export const addDiseasesAction = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/diseasesAction/', { data });
    if (res.message) {
      dispatch({ type:DISEASESACTION_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const diseasesAction = getState().get('farm').get('diseasesAction');
    diseasesAction.push(res);

    dispatch({ type:DISEASESACTION_LOAD_SUCCESS, diseasesAction: Object.assign([], diseasesAction) });
    return res;
  } catch (error) {
    dispatch({ type:DISEASESACTION_LOAD_FAIL, errorMessage: error });
  }
};

/**
 * Send email
 */

export const sendEmail = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SENDEMAIL_LOAD})
  try {
    const res = await api.post('/farm/send-info-email', { data });
    if (res.message) {
      dispatch({ type: SENDEMAIL_LOAD_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SENDEMAIL_LOAD_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SENDEMAIL_LOAD_FAIL, errorMessage: error.message || error })
  }
}

/**
 * Re Tax Send to portal
 */

export const sendToPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.put('/farm/send-to-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error })
  }
}

/**
 * Get farms all messages with farm id
 */

export const farmGetMessage = (farmId) => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.get('/farm/farmGetMessage/' + farmId);
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }

    dispatch({ type: MESSAGE_LOAD_SUCCESS, MESSAGE: res });
    return res;
  } catch (error) {
    dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: error });
  }
};

/**
 * Delete message board messages
 */

export const farmDeleteMessage = (dataID) => async (dispatch, getState, api) => {
  const data = { id : dataID };
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.del('/farm/farmDeleteMessage', { data });
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    
    dispatch({ type: MESSAGE_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Add message for the farms
 */

export const farmAddMessage = (data) => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.post('/farm/farmAddMessage', { data });
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: MESSAGE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Get All mass messages
 */

export const getAllMassMessage = () => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.get('/farm/get-mass-messages');
    if (res.message) {
      dispatch({ type: GET_MASS_MESSAGES_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: GET_MASS_MESSAGES_SUCCESS, massMessage: res });
    return res;
  } catch (error) {
    dispatch({ type: GET_MASS_MESSAGES_FAIL, errorMessage: error.message || error });
  }
}

/**
 * Update Mass Message 
 */

export const updateMessage = (data) => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.put('/farm/update-mass-messages', {data});
    if (res.message) {
      dispatch({ type: UPDATE_MASS_MESSAGES_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: UPDATE_MASS_MESSAGES_SUCCESS, massMessage: res });
    return res;
  } catch (error) {
    dispatch({ type: UPDATE_MASS_MESSAGES_FAIL, errorMessage: error.message || error });
  }
}

/**
 * EOY add/remove file in Past section
 */

export const addEoyPastFile = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/eoyPastFile', { data });
    if (res.message) {
      dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMEOYUPLOADS_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMEOYUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Misc add/remove file in Past section
 */

export const addMiscPastFile = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/miscPastFile', { data });
    if (res.message) {
      dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMMISCUPLOADS_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMMISCUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Mass Message Archive message
 */

export const farmArchiveMessage = (id) => async (dispatch, getState, api) => {
  const data = { id : id };
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.put('/farm/archive-message', { data });
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    
    dispatch({ type: MESSAGE_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Get All Archive mass messages
 */

export const getAllArchiveMassMessage = () => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.get('/farm/get-archive-mass-messages');
    if (res.message) {
      dispatch({ type: GET_MASS_MESSAGES_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: GET_MASS_MESSAGES_SUCCESS, massMessage: res });
    return res;
  } catch (error) {
    dispatch({ type: GET_MASS_MESSAGES_FAIL, errorMessage: error.message || error });
  }
}

/**
 * Remove Archive message
 */

export const removeArchiveMessage = (dataId) => async (dispatch, getState, api) => {
  const data = { id : dataId };
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.put('/farm/remove-archive', {data});
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: MESSAGE_LOAD_SUCCESS, massMessage: res });
    return res;
  } catch (error) {
    dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: error.message || error });
  }
}

/**
 * Message board 
 */

export const farmAddOwnerMessage = (data) => async (dispatch, getState, api) => {
  dispatch({ type: MESSAGE_LOAD });
  try {
    const res = await api.post('/farm/farmAddOwnerMessage', { data });
    if (res.message) {
      dispatch({ type: MESSAGE_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: MESSAGE_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * farm inspection image
 */

export const farmAddInspectionImg = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/farmAddInspectionImg', { data });
    if (res.message) {
      dispatch({ type: FARMINSPUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARMINSPUPLOADS_LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: FARMINSPUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Get upload inspection image
 */

export const getInspectionImg = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    const res = await api.post('/farm/get-inspection-image', { data });
    if (res.message) {
      dispatch({ type: GET_INSP_UPLOADS_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: GET_INSP_UPLOADS_SUCCESS, getInspImage: res });
    return res;
  } catch (error) {
    dispatch({ type: GET_INSP_UPLOADS_FAIL, errorMessage: error.message || error });
  }
};

/**
 * get upload inspection image
 */

export const imageDetail = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/get-image-uploads', { data });
    if (res.message) {
      dispatch({ type: INSPECTION_IMG_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: INSPECTION_IMG_LOAD_SUCCESS, imgFileUploads: res });
    return res;
  } catch (error) {
    dispatch({ type: INSPECTION_IMG_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * remove inspection image
 */

export const removeInspectionImg = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/farm/remove-image-uploads', { data });
    if (res.message) {
      dispatch({ type: REMOVE_INSPECTION_IMG_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: REMOVE_INSPECTION_IMG_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: REMOVE_INSPECTION_IMG_LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Send to portal of inspection
 */

export const sendToInsPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-insp-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error })
  }
}

/**
 * send To Lease Portal
 */

export const sendToLeasePortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-lease-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error })
  }
}

/**
 * Already generated Pdf send to lease portal
 */


 export const sendPdfToLeasePortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD})
  try {
    const res = await api.post('/farm/send-pdf-to-lease-portal', { data });
    if (res.message) {
      dispatch({ type: LEASE_PDF_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASE_PDF_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASE_PDF_FAIL, errorMessage: error.message || error });
    return error;
  }
}

/**
 * insurance crop pdf files send to portal 
 */

export const sendCropPdfToPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-crop-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error });
    return error;
  }
}

/**
 * Insurance pre crop pdf files send to portal
 */

export const sendPreCropPdfToPortal= (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-pre-crop-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error });
    return error;
  }
}

/**
 * Misc crop send to portal
 */

export const sendToMiscPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-misc-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error });
    return error;
  }
}

/**
 * Eoy crop send to portal
 */

export const sendToEoyPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-eoy-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error });
    return error;
  }
}

/**
 * Crop Prod send to portal
 */

export const sendToCropProdPortal = (data) => async (dispatch, getState, api) => {
  dispatch({ type: SEND_TO_PORTAL})
  try {
    const res = await api.post('/farm/send-to-crop-prod-portal', { data });
    if (res.message) {
      dispatch({ type: SEND_TO_PORTAL_SUCCESS, errorMessage: res.message });
      return;
    }
    dispatch({ type: SEND_TO_PORTAL_FAIL, result: res });
    return res;
  } catch (error) {
    dispatch({ type: SEND_TO_PORTAL_FAIL, errorMessage: error.message || error });
    return error;
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/farm.js